/**
 * The conversations of whoever is standing in front of you.
 *
 * With nothing open, this window used to say that nobody was chosen and that
 * somebody should go and open one from the NPCs list. That is a window telling
 * you to use a different window. Almost anybody who opens this has just been
 * looking at the character they want to write for, so this offers those: every
 * character in view, with how much has been written for each.
 */

import type { NpcDefinitionWire } from '@inverse/protocol';

export function DialogueNearby({
  characters,
  nearby,
  onOpen,
}: {
  characters: readonly NpcDefinitionWire[];
  /** The kinds of character in view, by definition. */
  nearby: readonly number[];
  onOpen: (npcId: number) => void;
}): JSX.Element {
  const held = nearby
    .map((id) => characters.find((one) => one.id === id))
    .filter((one): one is NpcDefinitionWire => one !== undefined)
    .sort((one, other) => one.name.localeCompare(other.name));

  if (held.length === 0) {
    return (
      <p className="hint">
        Nobody in sight. Anybody the camera can see turns up here, or open one from the NPCs list.
      </p>
    );
  }

  return (
    <>
      <p className="hint">Everybody in sight. Pick one to write what they say.</p>

      <div className="editor-list">
        {held.map((one) => (
          <button
            key={one.id}
            type="button"
            className="editor-row"
            title={`Write what ${one.name} says`}
            onClick={() => onOpen(one.id)}
          >
            <span>{one.name}</span>
            <span className="editor-row-id">
              {one.combatLevel > 0 ? `level ${one.combatLevel}` : 'talks'}
            </span>
          </button>
        ))}
      </div>
    </>
  );
}
